export default "__VITE_ASSET__b01a39ab__"